import { Image } from "@mantine/core";
import haraka from "../../assets/vehicles/haraka.png";
import xl from "../../assets/vehicles/xl.png";
import bajaji from "../../assets/vehicles/bajaji.png";
import boda from "../../assets/vehicles/boda.png";

// Same resolution the rider app uses (VehicleIconResolver): by ride-type
// name first, falling back to the LATRA vehicle type, then a car.
const BY_NAME: Record<string, string> = {
  "safiri haraka": haraka,
  safirixl: xl,
  "safiri xl": xl,
  boda,
  bajaji,
};
const BY_LATRA: Record<string, string> = { motorcycle: boda, tricycle: bajaji, car: haraka };

export function vehicleImage(rideTypeName?: string | null, latraType?: string | null): string {
  const byName = rideTypeName ? BY_NAME[rideTypeName.trim().toLowerCase()] : undefined;
  return byName ?? (latraType ? BY_LATRA[latraType] : undefined) ?? haraka;
}

/** Top-down vehicle artwork from the apps, sized for list rows. */
export function VehicleIcon({
  rideType,
  latraType,
  size = 28,
}: {
  rideType?: string | null;
  latraType?: string | null;
  size?: number;
}) {
  // Sits on a mist chip in dark theme: the artwork is drawn for light
  // backgrounds and the black Bajaji/Boda would vanish on #131617.
  return (
    <span className="vehicle-chip" aria-hidden style={{ width: size + 8, height: size * 0.62 + 6 }}>
      <Image src={vehicleImage(rideType, latraType)} w={size} h={size * 0.62} fit="contain" alt="" />
    </span>
  );
}
